import React from 'react';
import { FaHeadphones, FaNewspaper, FaGlobe, FaVideo, FaShareAlt } from 'react-icons/fa';

const ServiceCard = ({ service }) => {
  const getIcon = (type) => {
    switch(type) {
      case 'audio': return <FaHeadphones className="service-icon" />;
      case 'print': return <FaNewspaper className="service-icon" />;
      case 'online': return <FaGlobe className="service-icon" />;
      case 'social': return <FaShareAlt className="service-icon" />;
      case 'video': return <FaVideo className="service-icon" />;
      default: return <FaGlobe className="service-icon" />;
    }
  };

  return (
    <div className="service-card">
      <a href={service.url} target="_blank" rel="noopener noreferrer" className="service-link">
        {getIcon(service.type)}
        <h3>{service.title}</h3>
        <p>{service.description}</p>
        <span className="visit-link">Visit Platform →</span>
      </a>
    </div>
  );
};

export default ServiceCard;